import React from 'react';

import {
    Button,
    Heading,
} from 'react-aria-components';

import {
    List,
    ListItem,
    Text,
    WDSModal,
} from 'wanderu-components';
import { localize } from 'wanderu-i18n';
import { CloseX } from 'wanderu-icons';

import styles from './FareClass.scss';

import type { FareClassType } from './types';
import type { TFunction } from 'i18next';

interface InfoModalProps {
    fareClasses: FareClassType[];
    setShowInfoModal: (show: boolean) => void;
    showInfoModal: boolean;
    t: TFunction;
}

const InfoModal = ({
    fareClasses,
    setShowInfoModal,
    showInfoModal,
    t,
}: InfoModalProps) => {
    return (
        <WDSModal
            classes={{
                dialog: styles.dialog,
                modal: styles.modal,
                modalOverlay: styles.modalOverlay,
            }}
            isOpen={showInfoModal}
            onOpenChange={setShowInfoModal}
            isDismissable
        >
            <div className={styles.dialogHeaderContainer}>
                <Heading className={styles.dialogHeader} slot="title">
                    {t<string>('fare-class', { count: 2 })}
                </Heading>
                <Button
                    className={styles.closeButton}
                    onPress={() => setShowInfoModal(false)}
                >
                    <CloseX />
                </Button>
            </div>
            <div className={styles.dialogCopyContainer}>
                {fareClasses.map((fare) => {
                    const {
                        code,
                        description = {},
                    } = fare;
                    const {
                        title,
                        header,
                        body,
                        footer,
                    } = description;

                    return (
                        <div key={code}>
                            <Text
                                className={styles.fareTitle}
                                bold
                            >
                                {title}
                            </Text>
                            {!!header && <Text className={styles.fareDescription}>{header}</Text>}
                            {!!body?.length && (
                                <List className={styles.fareList}>
                                    {body.map((item, index) => (
                                        <ListItem
                                            className={styles.fareListItem}
                                            key={`listItem-${index}`}
                                        >
                                            {item}
                                        </ListItem>
                                    ))}
                                </List>
                            )}
                            {!!footer && <Text className={styles.fareDescription}>{footer}</Text>}
                        </div>
                    );
                })}
            </div>
        </WDSModal>
    );
};

export default localize(InfoModal, ['t'], 'baseApp');
